import * as React from 'react';

// icons
import 'font-awesome/css/font-awesome.min.css';

// styling
import 'bootstrap/dist/css/bootstrap.min.css';
import './assessmentPage.scss';

// toast
import 'react-toastify/dist/ReactToastify.css';

// flags
import 'flag-icon-css/css/flag-icon.css';

// services
import {createItemGen, currentBaseUrl, currentUser, currentUserId, deleteItemGen, getGeneralSmartTableData, isUserLoggedIn, updateItemGen, uploadItem} from '../../common/services';

// components
import Loader from 'react-loader'
import NavBar from '../../components/CustomNav/CustomNav.Component';

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer} from 'react-toastify';

// reactstrap
// import {Col, Row } from 'reactstrap';
import SmartDataTable from 'react-smart-data-table'

// hidable progress
import HidableProgress from '../../common/hidableProgress.Component';

// radio
import Radio from '@material-ui/core/Radio';

// draglist
import ReactDragList from 'react-drag-list';
import 'react-drag-list/assets/index.css';

// tabs
import {Breadcrumb, BreadcrumbItem, Button,ButtonDropdown, Card, CardBody, CardHeader,Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Pagination, PaginationItem, PaginationLink, Row, TabContent, Table, TabPane} from 'reactstrap';

class SingleAssessmentPage extends React.Component {
    public state = {
      activeTab: '1',
      answereditmodal: false,
      answerfields: {
        answer: 'AnswerCopy',
        id: 'id',
      },
      answermodal: false,
      answers: [],
      assessment_info: {},
      assessmentfields: {
        enabled: 'Enabled',
        id: 'id',
        name: 'Title',
        version: 'Version',
      },
      assessmentuploadmodal: false,
      assessmentuploadmodalupgraded: false,
      assetfields: {
        id: 'id',
        name: 'Title',
        },
      assets: [],
      baseurl: currentBaseUrl(),
      behaviour_feedback: [],
      behaviourfields: {
        id: 'id',
        name: 'Name',
      },
      behaviourmodal: false,
      behaviours: [],
      currentquestionid: 0,
      currentquestionidx: 0,
      destination: '',
      feedbackmodal: false,
      iconfields:{
        id: 'id',
        name: 'Title',
      },
      icons: [],
      loaded: false,
      mounted: false,
      navigate: false,
      processingmodal: false,
      question_groups: [],
      questionanswers: [] as any[],
      questionfields: {
        id: 'id',
        question: 'Question',
        },
      questionmodal: false,
      questions: [] as any[],
      questionstep: 0,
      tologin: false,
      uploadprogress: 0,
      uploadstatus: "active",
      username: '',
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
        this.setTab = this.setTab.bind(this);
        this.assessmentuploadtoggle = this.assessmentuploadtoggle.bind(this);
        this.assessmentuploadtoggleupgraded = this.assessmentuploadtoggleupgraded.bind(this);
        this.questiontoggle = this.questiontoggle.bind(this);
        this.answertoggle = this.answertoggle.bind(this);
        this.behaviourtoggle = this.behaviourtoggle.bind(this);
        this.answeredittoggle = this.answeredittoggle.bind(this);
        this.feedbacktoggle = this.feedbacktoggle.bind(this);
        this.feedbackSubmit = this.feedbackSubmit.bind(this);
        // progress
        this.onuploadprogress = this.onuploadprogress.bind(this);
        this.onuploadcomplete = this.onuploadcomplete.bind(this);
        // row events
        this.handleAddAnswerClicked = this.handleAddAnswerClicked.bind(this); 
        this.handleDeleteQuestionClicked = this.handleDeleteQuestionClicked.bind(this); 
        this.handleEditAnswerClicked = this.handleEditAnswerClicked.bind(this);
        this.refreshCurrentAnswers = this.refreshCurrentAnswers.bind(this);
        this.handleAnswerDelete = this.handleAnswerDelete.bind(this);

        this.orderSubmit = this.orderSubmit.bind(this);

        this.onEnableSelected = this.onEnableSelected.bind(this);
        this.onDisableSelected = this.onDisableSelected.bind(this);

        this.getQuestionFromId = this.getQuestionFromId.bind(this);
        this.getAnswerFromId = this.getAnswerFromId.bind(this);
        this.handleAnswerChange = this.handleAnswerChange.bind(this);
        this.handleAnswerUpdate = this.handleAnswerUpdate.bind(this);
        this.handleGenUpdatedAns = this.handleGenUpdatedAns.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleGenDelAns = this.handleGenDelAns.bind(this);
        this.handleQuestionDelete = this.handleQuestionDelete.bind(this);
        this.preview = this.preview.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.handleQuestionChange = this.handleQuestionChange.bind(this);
    }

    public preview () {
        const dest = currentBaseUrl() + 'assessmentpreview/' + this.currentid();
        
        console.log(dest)
        
        this.setState({
            navigate: true,
            destination: dest
        })

    }

    public assessmentuploadtoggle() {
        this.setState({
          assessmentuploadmodal: !this.state.assessmentuploadmodal,
        });
    }

    public assessmentuploadtoggleupgraded() {
        this.setState({
          assessmentuploadmodalupgraded: !this.state.assessmentuploadmodalupgraded,
        });
    }

    public questiontoggle() {
        this.setState({
          questionmodal: !this.state.questionmodal,
        });
    }

    public handleGenUpdatedAns (res) {
        console.log(res)
        toast.success('Update successful')
    }

    public handleGenUpdatedQuestion (res) {
        console.log(res)
        toast.success('Update successful')
    }

    public handleGenDelAns (res, ansid) {
        console.log(res)
        // toast('Update successful')
        // tslint:disable-next-line no-string-literal
        const newanswers = this.state.questionanswers.filter(e => e['id'] !== ansid);
        this.setState({questionanswers: newanswers});
        this.forceUpdate();
    }

    public handleAnswerUpdate(row) {
        // console.log(row);
        const item = {
            AnswerCopy: row.AnswerCopy,
            AssessmentQuestion: row.QuestionId,
            score: row.score,
            DisplayOrder: row.DisplayOrder,
            Assessment: this.currentid()
        }

        updateItemGen( 'admin/assessment_question_answers/' + row.id + '/', item,text => this.handleGenUpdatedAns(text));
    }

    public handleAnswerDelete(row) {
        const retVal = confirm("Do you want to continue ?");
        if(retVal === true) {
                  console.log('delete accepted');
                  deleteItemGen( 'admin/assessment_question_answers/' + row.id + '/', text => this.handleGenDelAns(text, row.id));
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public answertoggle() {
        this.setState({
          answermodal: !this.state.answermodal,
        });
    }

    public answeredittoggle() {
        this.setState({
          answereditmodal: !this.state.answereditmodal,
        });
    }

    public behaviourtoggle() {
        this.setState({
          behaviourmodal: !this.state.behaviourmodal,
        });
    }

    public feedbacktoggle() {
        this.setState({
            feedbackmodal: !this.state.feedbackmodal,
        });
    }

    public orderSubmit = () => {
        // event.preventDefault()
        this.setState({processingmodal: true})

        const item = {
            DisplayItems: JSON.stringify(this.state.questions),
        }

        createItemGen( 'admin/assessment_questions/update_order/', item, text => this.handleGenCreatedItemLoaded('admin/assessment_questions/by_assessment/?id=' + this.currentid(), 'questions', 'questions',text));
      }

    public onLogout(arg) {
        console.log('Logout in Parent', arg);
        this.setState({tologin: true});
    }

    public checkFile(fname, extenstion='csv') {
        let fileExtension = "";
        if (fname.lastIndexOf(".") > 0) {
            fileExtension = fname.substring(fname.lastIndexOf(".") + 1, fname.length);
        }
        if (fileExtension.toLowerCase() === extenstion) {
            return true;
        }
        else {
            toast.warn(fname + " is not a valid " + extenstion + " file for upload");
            return false;
        }
    }

    public onuploadprogress(val) {
        console.log(val);
        this.setState({uploadprogress: parseFloat(val)})
    }

    public onuploadcomplete(resp, refreshpath, refreshkey, arraykey) {
        if(resp.code ===200){
            this.setState({uploadstatus: "success"});
            toast.success('Successful upload');
            this.setState({processingmodal: false});
            getGeneralSmartTableData( refreshpath, text => this.handleGenSmartDataLoaded(refreshkey, arraykey,text));

            if(refreshkey ==='levels') {
                this.assessmentuploadtoggle();
            }

            if(refreshkey ==='questions') {
                this.assessmentuploadtoggle();
            }
        }
        else{
            toast.error('Error uploading, check file');
            this.setState({processingmodal: false});
            this.setState({uploadstatus: "error"});
        }
    }

    public handleUpdate = (evt, updated) => {
        // console.log(evt); // tslint:disable-line
        console.log(updated); // tslint:disable-line
        this.state.questions = updated;
        this.orderSubmit();

    }

    public draglist()  {

        return(
            <ReactDragList
                dataSource={this.state.questions}
                onUpdate={this.handleUpdate}
                    rowKey="id"
                   // tslint:disable-next-line jsx-no-lambda
                    row = {(record, index) =>
                                <div key={index} style={{ color: '#FFFF', backgroundColor: 'grey'  , border: 'none', margin: 13, padding: 9}}>
                                        <div className="simple-drag-row-title" style={{margin: 3}}>
                                            <textarea style={{fontSize: '13px'}} rows={4} cols={66} value={record[this.state.questionfields.question]} onChange= {(e) => this.handleQuestionChange(index, e)}/>
                                                
                                            <Button style={{marginLeft: '13px'}} onClick= {(e) => this.handleQuestionUpdate(record, e)}>Update</Button>
                                        </div>
                                </div>
                            }
                            handles={false}
                            className="simple-drag"
                            rowClassName="simple-drag-row"
                            />
        );
    }

    public handleQuestionChange(index, e) {
        console.log(e)
        this.state.questions[index][this.state.questionfields.question] = e.target.value;
        this.forceUpdate();
    }

    public handleQuestionUpdate(row, e) {
        console.log(row);

        const item = {
            Question: row[this.state.questionfields.question]
        }

        updateItemGen( 'admin/assessment_questions/' + row.id + '/change_general/', item,text => this.handleGenUpdatedQuestion(text));
    }

    public uploadSubmit = (event) => {
        event.preventDefault()

        const fileInputElement = event.target.elements.upld;
        const formData = new FormData();

        formData.append('assessment', this.currentid());

        let hasFile = false;

        for (const row of fileInputElement.files) {
            if(this.checkFile(row.name)) {
                formData.append('files', row);
                hasFile = true;
            }
            console.log(row.name);
            // console.log('acceptable:', this.checkFile(row.name));
        }

        if(hasFile){
            this.setState({processingmodal: true})
            this.setState({uploadprogress: 0})
            this.setState({uploadstatus: "active"})
            uploadItem("admin/assessment_questions/csv_upload_v0/", formData, text => this.onuploadprogress(text), text => this.onuploadcomplete(text, 'admin/assessment_questions/by_assessment/?id='+ this.currentid(), 'questions', 'questions'));
        }


    }

    public uploadSubmitupgraded = (event) => {
        event.preventDefault()

        const fileInputElement = event.target.elements.upld;
        const formData = new FormData();

        formData.append('assessment', this.currentid());

        let hasFile = false;

        for (const row of fileInputElement.files) {
            if(this.checkFile(row.name, 'zip')) {
                formData.append('files', row);
                hasFile = true;
            }
            console.log(row.name);
            // console.log('acceptable:', this.checkFile(row.name));
        }

        if(hasFile){
            this.setState({processingmodal: true})
            this.setState({uploadprogress: 0})
            this.setState({uploadstatus: "active"})
            uploadItem("admin/assessment_questions/zip_upload_v1/", formData, text => this.onuploadprogress(text), text => this.onuploadcomplete(text, 'admin/assessment_questions/by_assessment/?id='+ this.currentid(), 'questions', 'questions'));
        }


    }

    public behaviourSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        const item = {
            Name: event.target.elements.name.value,
        }

        createItemGen( 'admin/behaviours/', item, text => this.handleGenCreatedItemLoaded('admin/behaviours/overview_items/', 'behaviours', 'behaviours',text));
      }

      public feedbackSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        const item = {
            Behaviour: event.target.elements.behaviour.value,
            FeedbackText_capability: event.target.elements.capability.value,
            FeedbackText_intervention: event.target.elements.intervention.value,
            FeedbackText_manifestation: event.target.elements.manifestation.value,
            RangeHigh: event.target.elements.rhigh.value,
            RangeLow: event.target.elements.rlow.value,
        }

        createItemGen( 'admin/behaviour_feedback/', item, text => this.handleGenCreatedItemLoaded('admin/behaviour_feedback/overview_items/', 'behaviour_feedback', 'behaviour_feedback',text));
      }

    public handleDummy(){
        console.log('done');
    }

    public filterAnswersByQuestion(questionid){
        const keyname = 'QuestionId';
        return this.state.answers.filter(answer => answer[keyname]===questionid);
    }

    public answerSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        // answer
        const item = {
            AnswerCopy: event.target.elements.answer.value,
            AnswerCopyForteacherReview: null,
            Assessment: this.currentid(),
            AssessmentQuestion: this.state.currentquestionid,
            Behaviour: null,
            BehaviourScore: 0,
            DisplayOrder: event.target.elements.order.value,
            Icon: null,
            score: event.target.elements.score.value,
        }

        if(this.state.assessment_info[this.state.assessmentfields.version] === 1.0) {
            item.AnswerCopyForteacherReview = event.target.elements.answerteacher.value;
            item.Behaviour = event.target.elements.behaviour.value;
            item.BehaviourScore = event.target.elements.bscore.value;
            item.Icon = event.target.elements.icon.value;
        }

        createItemGen( 'admin/assessment_question_answers/', item, text => this.handleGenCreatedItemLoaded('admin/assessment_question_answers/by_assessment/?id=' + this.currentid(), 'answers', 'answers',text));
      }

    public groupSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        const item = {
            Colour: event.target.elements.color.value,
            Description: event.target.elements.description.value,
            Icon: event.target.elements.icon.value,
            Name: event.target.elements.title.value,
        }

        console.log(item);

        createItemGen( 'admin/assessment_question_groups/', item, text => this.handleGenCreatedItemLoaded('admin/assessment_question_groups/overview_items/', 'question_groups', 'question_groups',text));
      }

      public questionSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})

        const item = {
            Assessment: this.currentid(),
            AssessmentQuestionGroup: event.target.elements.group.value,
            Asset: null,
            DisplayOrder: event.target.elements.order.value,
            Icon: null,
            Question: event.target.elements.question.value,
            QuestionForteacherReview: null,
            User: currentUserId(),
            isDisplayGraphic: 0,
        }
        // optional fields
        if(this.state.assessment_info[this.state.assessmentfields.version] === 1.0) {
            item.Asset = event.target.elements.asset.value;
            item.Icon = event.target.elements.icon.value;
            item.QuestionForteacherReview = event.target.elements.review.value;
        }

        createItemGen( 'admin/assessment_questions/', item, text => this.handleGenCreatedItemLoaded('admin/assessment_questions/by_assessment/?id=' + this.currentid(), 'questions', 'questions',text));
      }

      public handleGenSmartDataLoaded(key,objkey, res) {
        if(res.code ===200){
            console.log(key);
            this.setState({loaded: true});
            this.setState({[key]: res.response[objkey]});
        }
        if(res.code ===401){
            this.onLogout('arg');
        }
    }


    public handleGenCreatedItemLoaded(fetchendpoint,refreshkey, arraykey, res) {
        if(res.code ===200){
            toast.success('Request successful');
            getGeneralSmartTableData( fetchendpoint, text => this.handleGenSmartDataLoaded(refreshkey, arraykey,text));
            if(refreshkey === 'question_groups') {
                setTimeout(this.assessmentuploadtoggle, 100);
            }
            else if(refreshkey === 'questions') {
                if(this.state.questionmodal) {
                    setTimeout(this.questiontoggle, 100);
                }
            }
            else if(refreshkey === 'behaviours') {
                setTimeout(this.behaviourtoggle, 100);
            }
            else if(refreshkey === 'behaviour_feedback') {
                setTimeout(this.feedbacktoggle, 100);
            }
            else if(refreshkey === 'answers') {
                setTimeout(this.answertoggle, 100);
            }

            this.setState({processingmodal: false});
        }
        if(res.code ===404){
            toast.error('Request failed, try again');
            this.setState({processingmodal: false});
        }
        if(res.code ===401){
            toast.warn('Request unauthorized');
            this.onLogout('arg');
        }
    }


    public setTab(param, e) {
        this.setState({
        activeTab: param
         });
    }


    public openWidget(param, e) {
        console.log('widget: ' + param)
        this.setState({destination: currentBaseUrl() + param})
        this.setState({navigate: true})
    }

    public onChange(arg) {
        console.log('On change', arg);
    }

    public handleAnswerChange(event){
        const ansid = event.currentTarget.dataset.arg;
        const newval = event.target.value;
        // console.log(event.target.value);
        // console.log(ansid);

        const curransidx = this.getAnswerFromId(ansid);

        console.log(curransidx);

        const copykey = "AnswerCopy"

        // console.log(this.state.questionanswers[curransidx])

        this.state.questionanswers[curransidx][copykey] = newval

        this.forceUpdate();
    }

    public getAnswerFromId(id) {

        const idkey = 'id';

        let idx = 0;

        for (const questionans of this.state.questionanswers) {
            if (questionans[idkey] === id) {
                return idx;
            }
            idx ++;
        }
        return 0
    }

    public handleDeleteQuestionClicked(row) {
        console.log('id', row.id);

        const retVal = confirm("Do you want to continue ?");
        
        if(retVal === true) {
                  console.log('delete accepted');
                  deleteItemGen( 'admin/assessment_questions/' + row.id + '/', text => this.handleQuestionDelete(text));
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public handleQuestionDelete(res) {
        if(res.code!==200) {
            toast.error('Unable to Delete');
        }
        else{
            toast.success('Item Deleted');
            getGeneralSmartTableData( 'admin/assessment_questions/by_assessment/?id=' + this.currentid(), text => this.handleGenSmartDataLoaded('questions', 'questions',text));
        }
    }

    public handleAddAnswerClicked(row) {
        console.log('id', row.id);
        this.setState({currentquestionid: row.id});
        // this.answertoggle();
        setTimeout(this.answertoggle, 100);
    }

    public handleEditAnswerClicked(row) {
        // console.log('idx', idx);
        this.setState({currentquestionid: row.id, questionanswers: []});
        setTimeout(this.refreshCurrentAnswers, 100);
    }

    public refreshCurrentAnswers(){
        this.answeredittoggle();
        getGeneralSmartTableData( 'admin/assessment_question_answers/by_question/?id=' + this.state.currentquestionid, text => this.handleGenSmartDataLoaded('questionanswers', 'answers',text));
    }

    public onRowClick(event, { rowData, rowIndex, tableData }) {
        const { title } = rowData;
        console.log(title);
    }

    public componentDidMount() {
        if(!isUserLoggedIn()){
            this.setState({ tologin: true });
          }
        else{
            this.setState({ username: currentUser()});
            getGeneralSmartTableData( 'admin/assessment_question_groups/overview_items/', text => this.handleGenSmartDataLoaded('question_groups', 'question_groups',text));
            getGeneralSmartTableData( 'admin/icons/overview_items/', text => this.handleGenSmartDataLoaded('icons', 'icons',text));
            getGeneralSmartTableData( 'admin/assessment_questions/by_assessment/?id=' + this.currentid(), text => this.handleGenSmartDataLoaded('questions', 'questions',text));
            getGeneralSmartTableData( 'admin/assessment_question_answers/by_assessment/?id=' + this.currentid(), text => this.handleGenSmartDataLoaded('answers', 'answers',text));
            getGeneralSmartTableData( 'admin/assets/overview_items/', text => this.handleGenSmartDataLoaded('assets', 'assets',text));
            getGeneralSmartTableData( 'admin/behaviours/overview_items/', text => this.handleGenSmartDataLoaded('behaviours', 'behaviours',text));
            getGeneralSmartTableData( 'admin/behaviour_feedback/overview_items/', text => this.handleGenSmartDataLoaded('behaviour_feedback', 'behaviour_feedback',text));
            getGeneralSmartTableData( 'admin/assessments/' + this.currentid() +'/assessment_summary/', text => this.handleGenSmartDataLoaded('assessment_info', 'assessment_info',text));
        }

        this.setState({ mounted: true});
        console.log(this.currentid());
    }

    public currentid (){
        const key1 = 'match';
        return this.props[key1].params.id
    }

    public getQuestionFromId(id) {

        const idkey = 'id';

        for (const question of this.state.questions) {
            if (question[idkey] === id) {
                return question;
            }
        }
        return {Question: 'not found'}
    }

    public questiondisplay (){
        if (this.state.questions.length > 0) {
            return (
                <Label>{this.getQuestionFromId(this.state.currentquestionid)[this.state.questionfields.question]}</Label>
              );
        }
        else{
            return (
                <h4>No question to display</h4>
              );
        }
    }

    public filteredanswerdisplay (){
        if (this.state.questions.length > 0 && this.state.questionanswers.length > 0) {
            return (
                <div>

                        <ul>
                            {this.state.questionanswers.map(d => <li style={{listStyle: 'none'}} key={d[this.state.answerfields.id]}> <Row> <Col> <textarea  data-arg={d[this.state.answerfields.id]} id={d[this.state.answerfields.id]} name={d[this.state.answerfields.id]} placeholder="AnswerCopy" required={true} value={d[this.state.answerfields.answer]} onChange={this.handleAnswerChange} style={{fontSize: 16}} rows={3} cols={50} /> </Col>
                            <Col>
                            {/* tslint:disable-next-line jsx-no-lambda*/}
                                <Button disabled={d[this.state.answerfields.answer].length < 1}  color="primary" style={{margin: '3px'}} onClick={() => this.handleAnswerUpdate(d)}>
                                    Update
                                </Button>

                            {/* tslint:disable-next-line jsx-no-lambda*/}
                            <Button disabled={d[this.state.answerfields.answer].length < 1}  color="primary" style={{margin: '3px'}} onClick={() => this.handleAnswerUpdate(d)}>
                                    Behaviour 
                            </Button>

                                {/* tslint:disable-next-line jsx-no-lambda*/}
                                <Button  color="warning" style={{margin: '3px'}} onClick={() => this.handleAnswerDelete(d)}>Delete</Button>
                            </Col> </Row> </li>)}
                        </ul>
                </div>

              );
        }
        else{
            return (
                <div>
                    <p>No answers to display</p>
                </div>

              );
        }
    }

    public assessmentenable () {
        if (this.state.assessment_info[this.state.assessmentfields.name]) {
            return (
                <div>
                    <ul>
                        <li>
                            <Radio
                                checked={this.state.assessment_info[this.state.assessmentfields.enabled]}
                                id={"enabled"}
                                value={1}
                                onClick={this.onEnableSelected}
                            />
                            Enabled
                        </li>
                        <li>
                            <Radio
                                checked={!this.state.assessment_info[this.state.assessmentfields.enabled]}
                                id={"disabled"}
                                value={0}
                                onClick={this.onDisableSelected}
                            />
                            Disabled
                        </li>
                    </ul>
                </div>

              );
        }
        else{
            return (
                <Loader color="#3EE9F7"/>
              );
        }

    }
    public optionalquestionformfields () {
        if (this.state.assessment_info[this.state.assessmentfields.version]) {

            if (this.state.assessment_info[this.state.assessmentfields.version] === 1.0){
                return (
                    <Row>
                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="color">For Teacher Review</Label>
                                                <Input type="text" id="review" name="review" placeholder="For teacher review" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="asset">Featured Asset</Label>
                                                <Input type="select" id="asset" name="asset" placeholder="asset" required={true} >
                                                    {this.state.assets.map(d => <option key={d[this.state.assetfields.id]} value={d[this.state.assetfields.id]}> {d[this.state.assetfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="icon">Icon</Label>
                                                <Input type="select" id="icon" name="icon" placeholder="Icon" required={true} >
                                                    {this.state.icons.map(d => <option key={d[this.state.iconfields.id]} value={d[this.state.iconfields.id]}> {d[this.state.iconfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                    </Row>
                );
            }
            else{
                return (
                    <div/>
                );
            }
        }
        else{
            return (
                <div/>
            );
        }
    }

    public optionalanswerformfields () {
        if (this.state.assessment_info[this.state.assessmentfields.version]) {

            if (this.state.assessment_info[this.state.assessmentfields.version] === 1.0){
                return (
                    <Row>
                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="answer">Answer Teacher review copy</Label>
                                                <Input type="text" id="answerteacher" name="answerteacher" placeholder="Answer teacher" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="answer">Behaviour Score</Label>
                                                <Input type="text" id="bscore" name="bscore" placeholder="e.g. 25" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="behaviour">Behaviour</Label>
                                                <Input type="select" id="behaviour" name="behaviour" placeholder="behaviour" required={true} >
                                                    {this.state.behaviours.map(d => <option key={d[this.state.behaviourfields.id]} value={d[this.state.behaviourfields.id]}> {d[this.state.behaviourfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="icon">Icon</Label>
                                                <Input type="select" id="icon" name="icon" placeholder="Icon" required={true} >
                                                    {this.state.icons.map(d => <option key={d[this.state.iconfields.id]} value={d[this.state.iconfields.id]}> {d[this.state.iconfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                    </Row>
                );
            }
            else{
                return (
                    <div/>
                );
            }
        }
        else{
            return (
                <div/>
            );
        }
    }

    public importsection (){

        if (this.state.assessment_info[this.state.assessmentfields.version]) {

            if (this.state.assessment_info[this.state.assessmentfields.version] === 0.5){
                return (
                    <Row style={{color: 'white'}}>
                    <Col xs="12" md="12">
                        <h4>Import Assessment Questions</h4>
                        <p>You can import a specially formatted file (v0.5) instead of manually typing in assessment data. The uploaded data will automatically populate the list if successful. You can download a <a href="http://media.mypl.life/samples/AssessmentQuestionsSampleX0.5.csv" target="_blank">Sample</a> here to get started</p>
                        <Button onClick={this.assessmentuploadtoggle}>Import From CSV</Button>

                    </Col>
                    </Row>
                );
            }

            else{
                return (
                    <Row>
                    <Col xs="12" md="12" style={{color: 'white'}}>
                    <h4>Import Assessment Questions</h4>
                    <p>You can import a specially formatted file (v1.0) instead of manually typing in assessment data. The uploaded data will automatically populate the list if successful. You can download a <a href="http://media.mypl.life/samples/1.0.zip" target="_blank">Sample</a> here to get started</p>
                    <Button disabled={false} onClick={this.assessmentuploadtoggleupgraded}>Import From zip</Button>

                </Col>
                </Row>
                );
            }
        }
        else{
            return (
                <div>
                    <Loader color="#3EE9F7"/>
                </div>
              );
        }
    }

    public onEnableSelected(event) {

        const item = {
            setting: 1
        }
        const retVal = confirm("Do you want to continue ?");
        if(retVal === true) {
                  console.log('change accepted');
                  updateItemGen( 'admin/assessments/' + this.currentid() + '/enable_assessment/', item,text => this.handleGenCreatedItemLoaded('admin/assessments/' + this.currentid() +'/assessment_summary/', 'assessment_info', 'assessment_info',text));
                  return true;
        } else {
            console.log('change canceled')
            return false;
        }
    }

    public onGoBack() {
        const dest = currentBaseUrl() + 'assessments';
        
        this.setState({
            navigate: true,
            destination: dest
        })
    }

    public onDisableSelected(event) {
        const item = {
            setting: 0
        }
        const retVal = confirm("Do you want to continue ?");
        if(retVal === true) {
                  console.log('change accepted');
                  updateItemGen( 'admin/assessments/' + this.currentid() + '/enable_assessment/', item,text => this.handleGenCreatedItemLoaded('admin/assessments/' + this.currentid() +'/assessment_summary/', 'assessment_info', 'assessment_info',text));
                  return true;
        } else {
            console.log('change canceled')
            return false;
        }
    }

    public render() {
        if (this.state.tologin === true) {
           return <Redirect to='/login'/>
        }
        if (this.state.navigate === true) {
            return <Redirect to={this.state.destination}/>
        }



        const groupfields= {
            id: 'id',
            name: 'Title',
        }


        const questionheaders = {
            UpdatedDateTimez: {
                filterable: false,
                sortable: false,
                text: 'Actions',
                transform: (value, idx) => (
                  <div>
                  <i
                    className="fa fa-plus-square"
                    style={{ cursor: 'pointer', margin: 6 }}
                    onClick={this.handleAddAnswerClicked.bind(this, idx)}
                    // onKeyDown={e => this.handleDelete(this, idx)}
                    role='button'
                  />
                  <i
                    className="fa fa-folder-open"
                    style={{ cursor: 'pointer' , margin: 6}}
                    onClick={this.handleEditAnswerClicked.bind(this, idx)}
                    role='button'
                  />
                  </div>
                ),
              },
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },
            UpdatedDateTime: {
                text: 'Actions',
                invisible: false,
                sortable: false,
                filterable: false,
                transform: (value, index, row) => {
                  // The following results should be identical
                  // outdisp(value, row.tableActions)
                  // Example of table actions: Delete row from data by row index
                  return (
                      <div style={{width: '350px'}}>
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <Button onClick={() => this.handleEditAnswerClicked(row)} color="primary" style={{margin: '3px'}}>
                            Edit Answers
                        </Button>
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <Button onClick={() => this.handleAddAnswerClicked(row)} color="success">
                            Add Answer
                        </Button>

                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <Button onClick={() => this.handleDeleteQuestionClicked(row)} color="danger">
                            Delete
                        </Button>
                    </div>
                  )
                },
            }

        }

        const behaviourheaders = {
            UpdatedDateTime: {
                filterable: false,
                sortable: false,
                text: 'Actions',
                transform: (value, idx) => (
                  <div>
                  <i
                    className="fa fa-edit"
                    style={{ cursor: 'pointer', margin: 6 }}
                    // onClick={this.handleAddAnswerClicked.bind(this, idx)}
                    // onKeyDown={e => this.handleDelete(e, idx)}
                    role='button'
                  />
                  </div>
                ),
              },
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },

        }

        const adminHomeStyles = {
            welcometext: {
                margin: 3,
                marginLeft: 13,
                marginTop: '2%'
            },

            modal:{
                width: '100%',
            },

            tabrow: {
                margin: 1,
                marginTop: '2%',
              },

            tabcontent: {
                margin: 1,
                marginTop: '2%'
            },

            tableHeaderButton: {
                margin: 2,
                marginLeft: 8,
            },

            widgetrow: {
              margin: 3,
              marginTop: '2%'
            },

            navitem: {
                margin: 3,
                padding: 5,
              },

            toast:{
                zIndex: 9999999,
            },
        }


        return (
            <div>

              <NavBar logoutParent={this.onLogout}/>

              <ToastContainer style={adminHomeStyles.toast} />

              <Breadcrumb>

                  <BreadcrumbItem><a onClick={this.openWidget.bind(this, 'home')}>Home</a></BreadcrumbItem>
                  <BreadcrumbItem active={false} onClick={this.onGoBack}>Assessments</BreadcrumbItem>
                  <BreadcrumbItem active={false}>Singleassessment</BreadcrumbItem>
                  <BreadcrumbItem active={true}>{this.state.assessment_info[this.state.assessmentfields.name]}</BreadcrumbItem>
                </Breadcrumb>

              <div className="animated fadeIn">

                <Row style={adminHomeStyles.tabrow}>

                <Col xs="12" md="12" className="mb-4">
                    <Nav tabs={true} style={{flexWrap: 'nowrap'}}>
                           <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '1')}>
                                Questions
                            </NavLink>
                        </NavItem>

                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '3')}>
                                Order
                            </NavLink>
                        </NavItem>
                        
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '2')}>
                                Status
                            </NavLink>
                        </NavItem>
                        
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '4')}>
                                Import
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <div>

                        <Modal isOpen={this.state.assessmentuploadmodal} toggle={this.assessmentuploadtoggle} className="adminmodal" >
                            <ModalHeader toggle={this.assessmentuploadtoggle}>Upload Assessment Questions</ModalHeader>
                            <ModalBody>
                                <form onSubmit={this.uploadSubmit}>
                                    <Row>

                                        <Col xs="12">
                                            <FormGroup>
                                                <input id="upld" type="file" name="upld" accept=".csv" multiple={true} required={true}/>
                                            </FormGroup>
                                        </Col>


                                        <Col xs="12">
                                            <FormGroup>
                                                <HidableProgress uploadprogress={this.state.uploadprogress} uploadstatus={this.state.uploadstatus} visible={this.state.processingmodal}/>
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Loader color="#3EE9F7" loaded={!this.state.processingmodal}>
                                        <Button className="adminmodalbutton" color="primary"  type="submit">Submit</Button>
                                        <Button className="adminmodalbutton" onClick={this.assessmentuploadtoggle}>Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>

                        <Modal isOpen={this.state.assessmentuploadmodalupgraded} toggle={this.assessmentuploadtoggleupgraded} className="">
                            <ModalHeader toggle={this.assessmentuploadtoggleupgraded}><Label>Upload Assessment Questions</Label></ModalHeader>
                            <ModalBody>
                                <form onSubmit={this.uploadSubmitupgraded}>
                                    <Row>

                                        <Col xs="12">
                                            <FormGroup>
                                                <input id="upld" type="file" name="upld" accept=".zip" multiple={true} required={true}/>
                                            </FormGroup>
                                        </Col>


                                        <Col xs="12">
                                            <FormGroup>
                                                <HidableProgress uploadprogress={this.state.uploadprogress} uploadstatus={this.state.uploadstatus} visible={this.state.processingmodal}/>
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Loader color="#3EE9F7" loaded={!this.state.processingmodal}>
                                        <Button className="adminmodalbutton"  color="primary"  type="submit">Submit</Button>
                                        <Button className="adminmodalbutton"  onClick={this.assessmentuploadtoggleupgraded}>Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>

                        <Modal style={adminHomeStyles.modal} isOpen={this.state.questionmodal} toggle={this.questiontoggle} className="">
                            <ModalHeader toggle={this.questiontoggle}>Create Question</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.questionSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="title">Question</Label>
                                                <Input type="text" id="question" name="question" placeholder="Question text" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="order">Display Order</Label>
                                                <Input type="select" id="order" name="order" placeholder="order" required={true} >
                                                    <option value="0">0</option>
                                                    {this.state.questions.map((d, i) => <option key={d[this.state.questionfields.id]} value={i + 1}>  {i +1}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="icon">Group</Label>
                                                <Input type="select" id="group" name="group" placeholder="group" required={true} >
                                                    {this.state.question_groups.map(d => <option key={d[groupfields.id]} value={d[groupfields.id]}> {d[groupfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        {this.optionalquestionformfields()}
                                    </Row>
                                    <Loader color="#3EE9F7" loaded={!this.state.processingmodal}>
                                        <Button className="adminmodalbutton"  color="primary"  type="submit">Submit</Button>
                                        <Button className="adminmodalbutton"  onClick={this.questiontoggle}>Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                        <Modal style={adminHomeStyles.modal} isOpen={this.state.answermodal} toggle={this.answertoggle} className="">
                            <ModalHeader toggle={this.answertoggle}>Create Answer</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.answerSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" >Question</Label>
                                                {this.questiondisplay()}

                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="answer">Answer copy</Label>
                                                <Input type="text" id="answer" name="answer" placeholder="Answer text" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="answer">Answer Score</Label>
                                                <Input type="text" id="score" name="score" placeholder="e.g. 25" required={true} />
                                            </FormGroup>
                                        </Col>



                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="order">Display Order</Label>
                                                <Input type="select" id="order" name="order" placeholder="order" required={true} >
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        {this.optionalanswerformfields()}
                                    </Row>
                                    <Loader color="#3EE9F7" loaded={!this.state.processingmodal}>
                                        <Button className="adminmodalbutton" color="primary"  type="submit">Submit</Button>
                                        <Button className="adminmodalbutton"  onClick={this.answertoggle}>Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>

                        <Modal style={adminHomeStyles.modal} isOpen={this.state.answereditmodal} toggle={this.answeredittoggle} className="">
                            <ModalHeader toggle={this.answeredittoggle}>Edit Answers</ModalHeader>
                            <ModalBody>
                                <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" >Question</Label>
                                                {this.questiondisplay()}

                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                        <Loader color="#3EE9F7" loaded={this.state.questionanswers.length > 0}>
                                            {this.filteredanswerdisplay()}
                                        </Loader>

                                        </Col>
                                </Row>

                            </ModalBody>
                        </Modal>
                    </div>
                    <TabContent activeTab={this.state.activeTab} style={adminHomeStyles.tabcontent}>
                        <TabPane tabId="1">
                            <Card className="admincard">
                                <CardHeader>
                                    <h5> Questions</h5>
                                    <Button onClick={this.questiontoggle}>Create</Button>

                                    <Button onClick={this.preview}>Preview</Button>
                                </CardHeader>
                                <CardBody>
                                    <Loader color="#3EE9F7" loaded={this.state.loaded}>

                                        <SmartDataTable
                                        data={this.state.questions}
                                        headers={questionheaders}
                                        name='Questions'
                                        perPage={10}
                                        className='ui compact selectable table admintable'
                                        sortable={false}
                                    />
                                    </Loader>
                                </CardBody>
                            </Card>
                        </TabPane>
                        <TabPane tabId="2">
                            <Card className="admincard">
                                <CardHeader>
                                    <h5> Options</h5>
                                </CardHeader>
                                <CardBody>
                                    {this.assessmentenable()}
                                </CardBody>
                            </Card>
                        </TabPane>
                        <TabPane tabId="3">
                            <Card className="admincard">
                                <CardHeader>
                                    <h5> Order</h5>
                                </CardHeader>
                                <CardBody>
                                {this.draglist()}

                                </CardBody>
                            </Card>
                        </TabPane>
                        <TabPane tabId="4">
                            {this.importsection()}
                        </TabPane>


                    </TabContent>
                </Col>
          </Row>

              </div>

            </div>
        )
    }
}

export default SingleAssessmentPage;


// WEBPACK FOOTER //
// ./src/pages/Singleassessment/assessmentPage.Component.tsx